<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('medicalorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderId" allow-clear placeholder="请输入订单编号"/>
              </a-form-item>
            </a-col>
            
            <a-col :md="8" :sm="24">
              <a-form-item label="药房类型">
                <!-- <a-input v-model="queryParam.pharmacytype" allow-clear placeholder="请输入药房类型"/> -->
                <a-select v-model="queryParam.pharmacyType"  allow-clear placeholder="请选择药房类型" :options="pharmacytypes"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态">
                <!-- <a-input v-model="queryParam.orderstate" allow-clear placeholder="请输入订单状态"/> -->
                <a-select v-model="queryParam.orderState"  allow-clear placeholder="请选择订单状态" :options="orderstates"></a-select>
              </a-form-item>
            </a-col>
            
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="药房名称">
                  <a-input v-model="queryParam.pharmacyName" allow-clear placeholder="请输入药房名称"/>
                </a-form-item>
              </a-col>
             <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.patientName" allow-clear placeholder="请输入姓名"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" >
          <x-down
            v-if="hasPerm('medicalorder:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
        
        <span  slot="patientsex" slot-scope="text, record">
            {{record.patientsex == '1'? '男' : '女'  }}
        </span>
        <span slot="negotiationFlag" slot-scope="text, record">
            {{ record.negotiationFlag == '0' ? '内配药房' : record.negotiationFlag == '1' ? '外配药房' : '内配药房'  }}
        </span>
        <span slot="orderstate" slot-scope="text, record">
            {{ record.orderstate == '0' ? '待付款' : record.orderstate == '2' ? '待发货' : record.orderstate == '8' ? '待收货' : record.orderstate == '9' ? '待取药' : record.orderstate == '4' ? '已取消' : record.orderstate == '6' ? '已退费' : ''  }}
        </span>


        <span slot="action"  slot-scope="text, record">
          
          <a @click="$refs.addForm.add(record)">
              查看
          </a>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import { medicalorderPage, medicalorderExport } from '@/api/modular/interhospital/medicalorder/medicalorderManage'
  import addForm from './viewDetial.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '提交时间',
            align: 'center',
            dataIndex: 'ctstamp'
          },
          {
            title: '订单编号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'patientage'
          },
          {
            title: '药房类型',
            align: 'center',
            dataIndex: 'negotiationFlag',
            scopedSlots: { customRender: 'negotiationFlag' },
          },
          {
            title: '药房名称',
            align: 'center',
            dataIndex: 'pharmacyname'
          },
          {
            title: '金额（元）',
            align: 'center',
            dataIndex: 'totalfee',
          },
          {
            title: '订单状态',
            align: 'center',
            dataIndex: 'orderstate',
            scopedSlots: { customRender: 'orderstate' },
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return new Promise(async(resolve,reject)=>{
             const res = await medicalorderPage(Object.assign(parameter, this.queryParam))
             resolve(res.data)
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        orderstates : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '待付款',
          },
          {
            value: '2',
            label: '待发货',
          },
          {
            value: '8',
            label: '待收货',
          },
          {
            value: '9',
            label: '已完成',
          },
          {
            value: '4',
            label: '已取消',
          },
          {
            value: '6',
            label: '已退费',
          },
        ],
        pharmacytypes : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '1',
            label: '内配药房',
          },
          {
            value: '2',
            label: '外配药房',
          },
        ]
      }
    },
    created () {
      if (this.hasPerm('medicalorder:edit') || this.hasPerm('medicalorder:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      // 展开查询条件
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        medicalorderExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },

      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  
</style>
